module.exports = __webpack_public_path__ + "img/tag_vip_only3@2x.bc69c16e.png";